<template>
    <div class="chatbot">
        <Chat :app="app"></Chat>
    </div>
</template>

<script>

import Chat from './Chat.vue'

export default {
    name: 'Chatbot',
    components: {
        Chat
    },
    props: {
        app: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            
        }
    }
}
</script>

<style scoped>

.chatbot {
    height: calc(100vh - 60px);
    display: flex;
    justify-content: center;
    padding: 60px 0 0 0;
}

</style>


// WEBPACK FOOTER //
// src/components/ChatbotScreen.vue